// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609031134/js/" + chunkId + "." + {"44":"4b7d6450","225":"0acd060f","481":"6f836e04","486":"a53ea6d6","770":"04031f37"}[chunkId] + ".0.7275991580840508.chunk.js";
};